import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Card, 
  CardContent, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Button, 
  Chip, 
  Avatar, 
  TextField, 
  InputAdornment, 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  IconButton, 
  Menu, 
  Checkbox, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon, 
  Divider, 
  Tooltip, 
  LinearProgress, 
  Tabs, 
  Tab, 
  Alert
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
  MoreVert as MoreVertIcon,
  Download as DownloadIcon,
  Refresh as RefreshIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  LocalShipping as LocalShippingIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Schedule as ScheduleIcon,
  Inventory as InventoryIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  Store as StoreIcon,
  AttachMoney as AttachMoneyIcon,
  ShoppingCart as ShoppingCartIcon,
  TrendingUp as TrendingUpIcon,
  Close as CloseIcon,
  Print as PrintIcon,
  Assignment as AssignmentIcon,
  SupportAgent as SupportAgentIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '4px',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    transform: 'translateY(-2px)',
  }
}));

const MetricCard = styled(Card)(({ gradient }) => ({
  background: gradient,
  color: 'white',
  borderRadius: '4px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  transition: 'all 0.3s ease',
  border: 'none',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.3)',
  }
}));

const AdminOrders = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOrderForMenu, setSelectedOrderForMenu] = useState(null);
  const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [bulkActionDialogOpen, setBulkActionDialogOpen] = useState(false);
  const [bulkAction, setBulkAction] = useState('');
  const [successAlert, setSuccessAlert] = useState('');

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleMenuOpen = (event, order) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrderForMenu(order);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedOrderForMenu(null);
  };

  const handleOrderDetailsOpen = (order) => {
    setSelectedOrderDetails(order);
    setOrderDetailsOpen(true);
    handleMenuClose();
  };

  const handleOrderDetailsClose = () => {
    setOrderDetailsOpen(false);
    setSelectedOrderDetails(null);
  };

  const handleSelectOrder = (orderId) => {
    setSelectedOrders(prev => 
      prev.includes(orderId) 
        ? prev.filter(id => id !== orderId)
        : [...prev, orderId]
    );
  };

  const handleSelectAllOrders = (checked) => {
    if (checked) {
      setSelectedOrders(filteredOrders.map(order => order.id));
    } else {
      setSelectedOrders([]);
    }
  };

  const handleBulkAction = (action) => {
    setBulkAction(action);
    setBulkActionDialogOpen(true);
  };

  const handleBulkActionConfirm = () => {
    // Implement bulk action logic here
    setSuccessAlert(`${selectedOrders.length}টি অর্ডারের জন্য ${bulkAction} সফলভাবে সম্পন্ন হয়েছে`);
    setSelectedOrders([]);
    setBulkActionDialogOpen(false);
    setTimeout(() => setSuccessAlert(''), 3000);
  };

  const handleStatusChange = (orderId, newStatus) => {
    // Implement status change logic here
    setSuccessAlert(`অর্ডার #${orderId} এর স্ট্যাটাস "${newStatus}" এ আপডেট করা হয়েছে`);
    handleMenuClose();
    setTimeout(() => setSuccessAlert(''), 3000);
  };

  // Mock data
  const orderStats = {
    totalOrders: 3560,
    pendingOrders: 145,
    processingOrders: 89,
    shippedOrders: 234,
    deliveredOrders: 2890,
    cancelledOrders: 202,
    todayRevenue: 245680,
    todayOrders: 87
  };

  const orders = [
    { 
      id: 1001, 
      customer: 'মাহমুদুর রহমান', 
      customerPhone: '০১৭২২৬১১১৮৫',
      customerAddress: '১২৩ মেইন স্ট্রিট, ঢাকা',
      date: '২৫ মার্চ, ২০২৫', 
      time: '২:৩০ PM',
      store: 'তাজা সবজি দোকান', 
      storeOwner: 'করিম উদ্দিন',
      status: 'ডেলিভারি সম্পন্ন', 
      amount: 1250,
      items: 5,
      paymentMethod: 'বিকাশ',
      deliveryFee: 50,
      placedBySupport: false,
      products: [
        { name: 'জৈব টমেটো', quantity: 2, price: 120, unit: 'কেজি' },
        { name: 'তাজা আলু', quantity: 3, price: 80, unit: 'কেজি' },
        { name: 'কাঁচা মরিচ', quantity: 1, price: 150, unit: 'কেজি' },
      ]
    },
    { 
      id: 1002, 
      customer: 'ফাতেমা খাতুন', 
      customerPhone: '০১৮৮৮৭৭৭১২৩',
      customerAddress: '৪৫৬ গার্ডেন রোড, চট্টগ্রাম',
      date: '২৫ মার্চ, ২০২৫', 
      time: '১:১৫ PM',
      store: 'মাংস প্যারাডাইজ', 
      storeOwner: 'রহিম আলী',
      status: 'প্রসেসিং', 
      amount: 890,
      items: 3,
      paymentMethod: 'নগদ',
      deliveryFee: 60,
      placedBySupport: true,
      supportAgent: 'সাকিব হাসান',
      products: [
        { name: 'দেশি মুরগি', quantity: 1, price: 450, unit: 'কেজি' },
        { name: 'গরুর মাংস', quantity: 1, price: 380, unit: 'কেজি' },
      ]
    },
    { 
      id: 1003, 
      customer: 'আহমেদ হাসান', 
      customerPhone: '০১৯৯৯৫৫৫৪৪৪',
      customerAddress: '৭৮৯ পার্ক এভিনিউ, সিলেট',
      date: '২৪ মার্চ, ২০২৫', 
      time: '৫:৪৫ PM',
      store: 'ফলের রাজ্য', 
      storeOwner: 'সালেহা খাতুন',
      status: 'অপেক্ষমান', 
      amount: 2300,
      items: 7,
      paymentMethod: 'ক্যাশ অন ডেলিভারি',
      deliveryFee: 80,
      placedBySupport: true,
      supportAgent: 'নাসিরা বেগম',
      products: [
        { name: 'কাঁচা আম', quantity: 3, price: 200, unit: 'কেজি' },
        { name: 'পাকা আম', quantity: 2, price: 350, unit: 'কেজি' },
        { name: 'কলা', quantity: 2, price: 100, unit: 'ডজন' },
      ]
    },
    { 
      id: 1004, 
      customer: 'রহিমা বেগম', 
      customerPhone: '০১৭৭৭৮৮৮৯৯৯',
      customerAddress: '৩২১ নিউ মার্কেট, রাজশাহী',
      date: '২৪ মার্চ, ২০২৫', 
      time: '১০:২০ AM',
      store: 'মিষ্টি কর্নার', 
      storeOwner: 'আলিম মিয়া',
      status: 'শিপ করা হয়েছে', 
      amount: 1750,
      items: 4,
      paymentMethod: 'কার্ড',
      deliveryFee: 70,
      placedBySupport: false,
      products: [
        { name: 'রসগোল্লা', quantity: 1, price: 400, unit: 'কেজি' },
        { name: 'চমচম', quantity: 1, price: 350, unit: 'কেজি' },
        { name: 'মিষ্টি দই', quantity: 2, price: 150, unit: 'কাপ' },
      ]
    },
    { 
      id: 1005, 
      customer: 'নাসির উদ্দিন', 
      customerPhone: '০১৫৫৫৬৬৬৭৭১',
      customerAddress: '৬৫৪ কলেজ রোড, খুলনা',
      date: '২৩ মার্চ, ২০২৫', 
      time: '৮:৩০ AM',
      store: 'দুগ্ধ ভান্ডার', 
      storeOwner: 'ফরিদা বেগম',
      status: 'বাতিল', 
      amount: 450,
      items: 2,
      paymentMethod: 'বিকাশ',
      deliveryFee: 40,
      placedBySupport: false,
      products: [
        { name: 'তাজা দুধ', quantity: 2, price: 60, unit: 'লিটার' },
        { name: 'দই', quantity: 1, price: 80, unit: 'কাপ' },
      ]
    },
  ];

  const tabs = [
    { label: 'সব অর্ডার', value: 'all', count: orderStats.totalOrders },
    { label: 'অপেক্ষমান', value: 'অপেক্ষমান', count: orderStats.pendingOrders },
    { label: 'প্রসেসিং', value: 'প্রসেসিং', count: orderStats.processingOrders },
    { label: 'শিপ করা হয়েছে', value: 'শিপ করা হয়েছে', count: orderStats.shippedOrders },
    { label: 'ডেলিভারি সম্পন্ন', value: 'ডেলিভারি সম্পন্ন', count: orderStats.deliveredOrders },
    { label: 'বাতিল', value: 'বাতিল', count: orderStats.cancelledOrders },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'ডেলিভারি সম্পন্ন': return 'success';
      case 'শিপ করা হয়েছে': return 'info';
      case 'প্রসেসিং': return 'primary';
      case 'অপেক্ষমান': return 'warning';
      case 'বাতিল': return 'error';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'ডেলিভারি সম্পন্ন': return <CheckCircleIcon />;
      case 'শিপ করা হয়েছে': return <LocalShippingIcon />;
      case 'প্রসেসিং': return <InventoryIcon />;
      case 'অপেক্ষমান': return <ScheduleIcon />;
      case 'বাতিল': return <CancelIcon />;
      default: return <ScheduleIcon />;
    }
  };

  const filteredOrders = orders.filter(order => {
    const matchesSearch = order.customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         order.id.toString().includes(searchTerm) ||
                         order.store.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || order.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const formatCurrency = (amount) => `৳${amount.toLocaleString()}`;

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          অর্ডার ম্যানেজমেন্ট
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            sx={{ borderRadius: '4px' }}
          >
            রিফ্রেশ
          </Button>
          
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            sx={{ borderRadius: '4px' }}
          >
            এক্সপোর্ট
          </Button>
          
          {selectedOrders.length > 0 && (
            <Button
              variant="contained"
              startIcon={<EditIcon />}
              onClick={() => handleBulkAction('স্ট্যাটাস আপডেট')}
              sx={{ borderRadius: '4px' }}
            >
              বাল্ক অ্যাকশন ({selectedOrders.length})
            </Button>
          )}
        </Box>
      </Box>

      {/* Success Alert */}
      {successAlert && (
        <Alert severity="success" sx={{ mb: 3 }}>
          {successAlert}
        </Alert>
      )}

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <MetricCard gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)">
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <ShoppingCartIcon sx={{ fontSize: 40, opacity: 0.8 }} />
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  আজকে
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                {orderStats.todayOrders}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                নতুন অর্ডার
              </Typography>
            </CardContent>
          </MetricCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MetricCard gradient="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)">
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <AttachMoneyIcon sx={{ fontSize: 40, opacity: 0.8 }} />
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  আজকে
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                {formatCurrency(orderStats.todayRevenue)}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                মোট রাজস্ব
              </Typography>
            </CardContent>
          </MetricCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MetricCard gradient="linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)">
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <ScheduleIcon sx={{ fontSize: 40, opacity: 0.8 }} />
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  পেন্ডিং
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                {orderStats.pendingOrders}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                অপেক্ষমান অর্ডার
              </Typography>
            </CardContent>
          </MetricCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <MetricCard gradient="linear-gradient(135deg, #fa709a 0%, #fee140 100%)">
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <TrendingUpIcon sx={{ fontSize: 40, opacity: 0.8 }} />
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  মোট
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                {orderStats.totalOrders.toLocaleString()}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                সব অর্ডার
              </Typography>
            </CardContent>
          </MetricCard>
        </Grid>
      </Grid>

      {/* Filters and Search */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              placeholder="অর্ডার ID, গ্রাহকের নাম বা দোকানের নাম দিয়ে খুঁজুন..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>স্ট্যাটাস ফিল্টার</InputLabel>
              <Select
                value={statusFilter}
                label="স্ট্যাটাস ফিল্টার"
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <MenuItem value="all">সব স্ট্যাটাস</MenuItem>
                <MenuItem value="অপেক্ষমান">অপেক্ষমান</MenuItem>
                <MenuItem value="প্রসেসিং">প্রসেসিং</MenuItem>
                <MenuItem value="শিপ করা হয়েছে">শিপ করা হয়েছে</MenuItem>
                <MenuItem value="ডেলিভারি সম্পন্ন">ডেলিভারি সম্পন্ন</MenuItem>
                <MenuItem value="বাতিল">বাতিল</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                fullWidth
              >
                আরও ফিল্টার
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Status Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs 
          value={currentTab} 
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500
            }
          }}
        >
          {tabs.map((tab, index) => (
            <Tab 
              key={index}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {tab.label}
                  <Chip label={tab.count} size="small" />
                </Box>
              }
              onClick={() => setStatusFilter(tab.value)}
            />
          ))}
        </Tabs>
      </Paper>

      {/* Orders Table */}
      <StyledCard>
        <CardContent sx={{ p: 0 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedOrders.length === filteredOrders.length && filteredOrders.length > 0}
                      indeterminate={selectedOrders.length > 0 && selectedOrders.length < filteredOrders.length}
                      onChange={(e) => handleSelectAllOrders(e.target.checked)}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>অর্ডার ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>গ্রাহক</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>দোকান</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>তারিখ ও সময়</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>স্ট্যাটাস</TableCell>
                  <TableCell sx={{ fontWeight: 600 }} align="right">পরিমাণ</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>পেমেন্ট</TableCell>
                  <TableCell sx={{ fontWeight: 600 }} align="center">অ্যাকশন</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredOrders.map((order) => (
                  <TableRow 
                    key={order.id}
                    hover
                    sx={{ 
                      '&:hover': { bgcolor: '#f8f9fa' },
                      bgcolor: selectedOrders.includes(order.id) ? '#e3f2fd' : 'inherit'
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedOrders.includes(order.id)}
                        onChange={() => handleSelectOrder(order.id)}
                      />
                    </TableCell>
                    
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: 'primary.main' }}>
                        #{order.id}
                      </Typography>
                    </TableCell>
                    
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ mr: 2, bgcolor: 'primary.main', width: 32, height: 32 }}>
                          <PersonIcon fontSize="small" />
                        </Avatar>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {order.customer}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {order.customerPhone}
                          </Typography>
                          {order.placedBySupport && (
                            <Box sx={{ mt: 0.5 }}>
                              <Chip 
                                label="কাস্টমার সাপোর্ট"
                                size="small"
                                icon={<SupportAgentIcon />}
                                sx={{ 
                                  bgcolor: '#e3f2fd',
                                  color: '#1976d2',
                                  fontSize: '0.7rem',
                                  height: '20px',
                                  '& .MuiChip-icon': {
                                    fontSize: '12px'
                                  }
                                }}
                              />
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </TableCell>
                    
                    <TableCell>
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {order.store}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {order.storeOwner}
                        </Typography>
                      </Box>
                    </TableCell>
                    
                    <TableCell>
                      <Box>
                        <Typography variant="body2">
                          {order.date}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {order.time}
                        </Typography>
                      </Box>
                    </TableCell>
                    
                    <TableCell>
                      <Chip 
                        label={order.status}
                        color={getStatusColor(order.status)}
                        icon={getStatusIcon(order.status)}
                        size="small"
                        sx={{ fontWeight: 600 }}
                      />
                    </TableCell>
                    
                    <TableCell align="right">
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {formatCurrency(order.amount)}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {order.items} আইটেম
                        </Typography>
                      </Box>
                    </TableCell>
                    
                    <TableCell>
                      <Chip 
                        label={order.paymentMethod}
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>
                    
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <Tooltip title="বিস্তারিত দেখুন">
                          <IconButton 
                            size="small" 
                            color="primary"
                            onClick={() => handleOrderDetailsOpen(order)}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        
                        <Tooltip title="আরও অপশন">
                          <IconButton 
                            size="small"
                            onClick={(e) => handleMenuOpen(e, order)}
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          {filteredOrders.length === 0 && (
            <Box sx={{ textAlign: 'center', py: 8 }}>
              <AssignmentIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                কোনো অর্ডার পাওয়া যায়নি
              </Typography>
              <Typography variant="body2" color="text.secondary">
                আপনার ফিল্টার অনুযায়ী কোনো অর্ডার খুঁজে পাওয়া যায়নি
              </Typography>
            </Box>
          )}
        </CardContent>
      </StyledCard>

      {/* Action Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => handleOrderDetailsOpen(selectedOrderForMenu)}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>বিস্তারিত দেখুন</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={() => handleStatusChange(selectedOrderForMenu?.id, 'প্রসেসিং')}>
          <ListItemIcon>
            <InventoryIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>প্রসেসিং করুন</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={() => handleStatusChange(selectedOrderForMenu?.id, 'শিপ করা হয়েছে')}>
          <ListItemIcon>
            <LocalShippingIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>শিপ করুন</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={() => handleStatusChange(selectedOrderForMenu?.id, 'ডেলিভারি সম্পন্ন')}>
          <ListItemIcon>
            <CheckCircleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>ডেলিভারি সম্পন্ন</ListItemText>
        </MenuItem>
        
        <Divider />
        
        <MenuItem>
          <ListItemIcon>
            <PrintIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>প্রিন্ট করুন</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={() => handleStatusChange(selectedOrderForMenu?.id, 'বাতিল')}>
          <ListItemIcon>
            <CancelIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText sx={{ color: 'error.main' }}>অর্ডার বাতিল</ListItemText>
        </MenuItem>
      </Menu>

      {/* Order Details Dialog */}
      <Dialog 
        open={orderDetailsOpen} 
        onClose={handleOrderDetailsClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h6">অর্ডার বিস্তারিত</Typography>
              <Typography variant="subtitle2" color="text.secondary">
                অর্ডার ID: #{selectedOrderDetails?.id}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Chip 
                label={selectedOrderDetails?.status}
                color={getStatusColor(selectedOrderDetails?.status)}
                icon={getStatusIcon(selectedOrderDetails?.status)}
              />
              <IconButton onClick={handleOrderDetailsClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        
        <DialogContent dividers>
          {selectedOrderDetails && (
            <Grid container spacing={3}>
              {/* Customer Information */}
              <Grid item xs={12} md={6}>
                <StyledCard>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonIcon color="primary" />
                      গ্রাহকের তথ্য
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500, mr: 1, minWidth: 60 }}>
                        নাম:
                      </Typography>
                      <Typography variant="body2">
                        {selectedOrderDetails.customer}
                      </Typography>
                    </Box>

                    {selectedOrderDetails.placedBySupport && (
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <SupportAgentIcon sx={{ mr: 1, color: 'primary.main', fontSize: 16 }} />
                        <Typography variant="body2" sx={{ fontWeight: 500, mr: 1 }}>
                          সাপোর্ট এজেন্ট:
                        </Typography>
                        <Typography variant="body2">
                          {selectedOrderDetails.supportAgent}
                        </Typography>
                        <Chip 
                          label="কাস্টমার সাপোর্ট দ্বারা স্থাপিত"
                          size="small"
                          color="info"
                          sx={{ ml: 1 }}
                        />
                      </Box>
                    )}
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <PhoneIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 16 }} />
                      <Typography variant="body2" sx={{ fontWeight: 500, mr: 1 }}>
                        ফোন:
                      </Typography>
                      <Typography variant="body2">
                        {selectedOrderDetails.customerPhone}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                      <LocationOnIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 16, mt: 0.2 }} />
                      <Typography variant="body2" sx={{ fontWeight: 500, mr: 1 }}>
                        ঠিকানা:
                      </Typography>
                      <Typography variant="body2" sx={{ flex: 1 }}>
                        {selectedOrderDetails.customerAddress}
                      </Typography>
                    </Box>
                  </CardContent>
                </StyledCard>
              </Grid>

              {/* Store Information */}
              <Grid item xs={12} md={6}>
                <StyledCard>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <StoreIcon color="primary" />
                      দোকানের তথ্য
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500, mr: 1, minWidth: 80 }}>
                        দোকানের নাম:
                      </Typography>
                      <Typography variant="body2">
                        {selectedOrderDetails.store}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500, mr: 1, minWidth: 80 }}>
                        মালিক:
                      </Typography>
                      <Typography variant="body2">
                        {selectedOrderDetails.storeOwner}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500, mr: 1, minWidth: 80 }}>
                        অর্ডারের সময়:
                      </Typography>
                      <Typography variant="body2">
                        {selectedOrderDetails.date} - {selectedOrderDetails.time}
                      </Typography>
                    </Box>
                  </CardContent>
                </StyledCard>
              </Grid>

              {/* Products List */}
              <Grid item xs={12}>
                <StyledCard>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <InventoryIcon color="primary" />
                      অর্ডার করা পণ্যসমূহ
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>পণ্যের নাম</TableCell>
                            <TableCell align="center">পরিমাণ</TableCell>
                            <TableCell align="right">একক দাম</TableCell>
                            <TableCell align="right">মোট দাম</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedOrderDetails.products?.map((product, index) => (
                            <TableRow key={index}>
                              <TableCell>{product.name}</TableCell>
                              <TableCell align="center">{product.quantity} {product.unit}</TableCell>
                              <TableCell align="right">৳{product.price}</TableCell>
                              <TableCell align="right">৳{(product.quantity * product.price).toLocaleString()}</TableCell>
                            </TableRow>
                          ))}
                          <TableRow>
                            <TableCell colSpan={3} sx={{ fontWeight: 600 }}>ডেলিভারি চার্জ</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 600 }}>৳{selectedOrderDetails.deliveryFee}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell colSpan={3} sx={{ fontWeight: 600, fontSize: '1.1rem' }}>মোট পরিমাণ</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: '1.1rem', color: 'primary.main' }}>
                              {formatCurrency(selectedOrderDetails.amount)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </StyledCard>
              </Grid>

              {/* Payment Information */}
              <Grid item xs={12}>
                <StyledCard>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <AttachMoneyIcon color="primary" />
                      পেমেন্ট তথ্য
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          পেমেন্ট পদ্ধতি: {selectedOrderDetails.paymentMethod}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          পেমেন্ট স্ট্যাটাস: 
                          <Chip 
                            label="সফল" 
                            color="success" 
                            size="small" 
                            sx={{ ml: 1 }}
                          />
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </StyledCard>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleOrderDetailsClose}>
            বন্ধ করুন
          </Button>
          
          <Button variant="outlined" startIcon={<PrintIcon />}>
            প্রিন্ট করুন
          </Button>
          
          <Button variant="contained" startIcon={<EditIcon />}>
            স্ট্যাটাস আপডেট
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Action Dialog */}
      <Dialog 
        open={bulkActionDialogOpen} 
        onClose={() => setBulkActionDialogOpen(false)}
      >
        <DialogTitle>বাল্ক অ্যাকশন নিশ্চিতকরণ</DialogTitle>
        <DialogContent>
          <Typography>
            আপনি কি নিশ্চিত যে আপনি {selectedOrders.length}টি অর্ডারের জন্য "{bulkAction}" সম্পাদন করতে চান?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkActionDialogOpen(false)}>বাতিল</Button>
          <Button variant="contained" onClick={handleBulkActionConfirm}>
            নিশ্চিত করুন
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminOrders;
